import { render, staticRenderFns } from "./Tema2_2-4.vue?vue&type=template&id=eb85186a&"
import script from "./Tema2_2-4.vue?vue&type=script&lang=js&"
export * from "./Tema2_2-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports